import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { PostHighlightAndRedirectResponseDto } from "../../../types/dto/chat/post-highlight-and-redirect-response-dto";
import { ChatMessage } from "../types/chat-message";
import { sendMessageLogSubmission } from "./send-message-log";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";
import { PostHighlightAndRedirectRequestDto } from "../../../types/dto/chat/post-highlight-and-redirect-request-dto";
import { setReqNudgeType } from "../chat-slice";
import { RequestNudgeType } from "../../../../application/utils/request-nudge-type";

export const hyperLinkClick = createAsyncThunk<
  void,
  {
    url: string,
    navigate: (data: PostHighlightAndRedirectResponseDto) => void,
    message: ChatMessage,
  }
>('chat-slice/hyper-link-click',
  async ({ navigate, url, message }, { getState, dispatch }) => {

    const rootState = getState() as RootState;
    const {
      merchId,
      sessionId,
      conversationId,
      suId,
    } = rootState["app-state"];

    const turn_id = message.turn_id || rootState.chat.streamingMessageTurnId!;
    const reqBody: PostHighlightAndRedirectRequestDto = {
      cust_id: merchId,
      conversation_id: conversationId,
      turn_id,
      session_id: sessionId,
      url: url,
      su_id: suId
    };

    const response = await axiosClient.post<PostHighlightAndRedirectResponseDto>('/highlightandredirect', reqBody);

    dispatch(sendMessageLogSubmission({ data: {
      message: getMessageByVurablizeEvent(VurbalizeEvents.REDIRECT_CLICKED, response.data.url),
      event_name: VurbalizeEvents.REDIRECT_CLICKED,
      event_data: {
        timestamp: Date.now(),
        redirectUrl: response.data.url,
      },
      turn_id,
    } }));
    dispatch(setReqNudgeType(RequestNudgeType.NEW_PAGE_VISIT));
    if (response?.data?.url.endsWith('.pdf')) {
      try {
        const downloadResponse = await fetch(response?.data?.url);
        const blob = await downloadResponse.blob();

        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);

        // Setting various property values
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = response?.data?.url.split('/').pop() || '';
        alink.click();
      } catch (e: unknown) {
        navigate(response.data);
      }

      return;
    }

    navigate(response.data);
  }
)
